import Cookies from "js-cookie";

// Persists a successful login/signup response (any auth path — phone/password
// or Google) as the same set of cookies the rest of the app reads: Header.js,
// ProfileCard.js, App.js's admin-state check, etc. Keeping this in one place
// means every auth path (LoginPopup, SignInPopUp, Google) produces an
// identical session shape.
export const applyAuthSession = (data) => {
  const roles = Array.isArray(data?.roles) ? data.roles : [];
  const token = `${data.type || "Bearer"} ${data.token}`;

  Cookies.set("username", data.username);
  Cookies.set("email", data.email);
  Cookies.set("phoneNo", data.phoneNo);
  Cookies.set("token", token);
  Cookies.set("roles", JSON.stringify(roles));

  const accountType = roles.includes("ROLE_ADMIN")
    ? "admin"
    : roles.includes("ROLE_COLLEGE")
    ? "college"
    : roles.includes("ROLE_AUTHOR")
    ? "author"
    : "student";
  Cookies.set("accountType", accountType);

  return { roles, accountType };
};
